import * as actionTypes from '../actions/type';

export const initialState = {
  userList: {} ,
  isProcessing: false,
  isProcessingBanner: true,
  statusCode: 0,
  type: null,
  banners: [],
  recommend_videos: [],
};

const homeReducers = (state  = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_HOME:
      // console.log('homeReducers ', action.type);
      return { 
        ...state, 
        isProcessing: true, 
        type: action.type 
      };
    case actionTypes.GET_USER_HOME_SUCCESS:
      // console.log('homeReducers success', action.type);
      return {
        ...state,
        isProcessing: false,
        statusCode: action.payload.statusCode,
        userList: action.payload.data.data,
        type: action.type,
      };
    case actionTypes.UPLOAD_IMG_REQUEST: 
      return {
        ...state,
        isProcessing: false,
        type: action.type,
      };
    case actionTypes.OPEN_MENU:
      return {
        ...state,
        isProcessing: false, 
        menuStatus: action.payload,
        type: action.type,
      };
    case actionTypes.GET_BANNER_HOME:
      // console.log('homeReducers ', action.type);
      return { 
        ...state, 
        isProcessingBanner: true,
        banners: [],
        type: action.type 
      };
    case actionTypes.GET_BANNER_HOME_SUCCESS:
      // console.log('homeReducers success aaaaaaaaaaaa', action);
      return {
        ...state,
        isProcessingBanner: false,
        statusCode: action.payload.status,
        banners: action.payload.data.data,
        type: action.type,
      };
    case actionTypes.GET_RECOMMEND_VIDEO:
      return { 
        ...state, 
        isProcessingBanner: true, 
        type: action.type 
      };
    case actionTypes.GET_RECOMMEND_VIDEO_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        statusCode: action.payload.status,
        recommend_videos: action.payload.data.data,
        type: action.type,
      };
    default:
      return state;
  }
};

export default homeReducers;
